(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    if (!window.__resourceListCarouselArrowMetricsInitialized) {
    const updateCarouselArrowMetrics = (carousel) => {
      const container = carousel.querySelector('slideshow-container');
      const media = carousel.querySelector('.resource-list__slide .card-gallery');

      if (!container || !media) {
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const mediaRect = media.getBoundingClientRect();

      const mediaTop = Math.max(0, mediaRect.top - containerRect.top);
      const mediaHeight = Math.max(0, mediaRect.height);

      if (mediaHeight <= 0) {
        return;
      }

      carousel.style.setProperty('--resource-list-carousel-media-top-measured', `${mediaTop}px`);
      carousel.style.setProperty('--resource-list-carousel-media-height-measured', `${mediaHeight}px`);
    };

    const setupCarousel = (carousel) => {
      if (carousel.dataset.arrowMetricsSetup == 'true') {
        return;
      }

      carousel.dataset.arrowMetricsSetup = 'true';

      const resizeObserver = new ResizeObserver(() => {
        updateCarouselArrowMetrics(carousel);
      });

      const observeElements = () => {
        const container = carousel.querySelector('slideshow-container');
        const media = carousel.querySelector('.resource-list__slide .card-gallery');

        if (container) {
          resizeObserver.observe(container);
        }

        if (media) {
          resizeObserver.observe(media);
        }

        updateCarouselArrowMetrics(carousel);
      };

      observeElements();

      const mutationObserver = new MutationObserver(() => {
        observeElements();
      });

      mutationObserver.observe(carousel, { childList: true, subtree: true });

      requestAnimationFrame(() => {
        updateCarouselArrowMetrics(carousel);
      });
    };

    const initializeCarousels = () => {
      document.querySelectorAll('.resource-list__carousel--slideshow').forEach((carousel) => {
        if (carousel.querySelector('slideshow-arrows')) {
          setupCarousel(carousel);
        }
      });
    };

    const updateAllCarouselMetrics = () => {
      document.querySelectorAll('.resource-list__carousel--slideshow').forEach((carousel) => {
        if (carousel.querySelector('slideshow-arrows')) {
          updateCarouselArrowMetrics(carousel);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCarousels);
    } else {
      initializeCarousels();
    }

    document.addEventListener('shopify:section:load', initializeCarousels);
    window.addEventListener('resize', updateAllCarouselMetrics);
    window.addEventListener('orientationchange', updateAllCarouselMetrics);
    window.__resourceListCarouselArrowMetricsInitialized = true;
  }
  } catch(e) { console.error(e); }
})();

})();
